(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/tt-restriction.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/tt-restriction.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  isPnp
} = svs.legal_info.data;
const {
  returnUrl
} = svs.legal_info.data.loginCheckOptions.model;
const TTRestriction = () => {
  const isCallOfCareUpdateEnabled = svs.core.detect.feature('ft-call-of-care-update');
  const getRestrictionContent = () => svs.accountservices.player_exclusions.template_literals.tt_restriction();
  return React.createElement("section", {
    className: "f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-sport-75',
    icon: "help-2",
    size: "1000"
  })), React.createElement("h1", {
    className: "align-center f-prominent padding-xs-h-1"
  }, "Just nu kan du inte spela eller s\xE4tta in pengar"), React.createElement("div", {
    className: "padding-xs-h-1 align-center",
    dangerouslySetInnerHTML: {
      __html: getRestrictionContent()
    }
  }), React.createElement("div", {
    className: "padding-xs-h-1 align-center"
  }, React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    href: isCallOfCareUpdateEnabled ? returnUrl : '/logga-ut',
    transparent: true
  }, isCallOfCareUpdateEnabled ? 'Stäng' : 'Logga ut')), React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: isPnp,
    href: isCallOfCareUpdateEnabled ? svs.core.urlMapping.get('gameCareContact') : returnUrl,
    inverted: !isPnp
  }, isCallOfCareUpdateEnabled ? 'Kontakta oss' : 'Gå vidare'))))));
};
svs.legal_info.components.login_check.self_exclusion_info.TTRestriction = TTRestriction;

 })(window);